

import "./AboutUs.css";

const AboutUs=()=>{
    return(
      <section className="ftco-menu  pb-5">
        <div>

<div className="container-xxl py-5 text-white">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6">
            <div className="row g-3">
              <div className="col-6 text-end">
                <img
                  className="img-fluid bg-white w-100 mb-3 wow fadeIn"
                  data-wow-delay="0.1s"
                  src="images/coffeeBg3.jpg"
                  alt=""
                />
                <img
                  className="img-fluid bg-white w-50 wow fadeIn"
                  data-wow-delay="0.2s"
                  src="images/coffeeImage1.jpg"
                  alt=""
                />
              </div>
              <div className="col-6">
                <img
                  className="img-fluid bg-white w-50 mb-3 wow fadeIn"
                  data-wow-delay="0.3s"
                  src="images/coffeeBg2.jpg"
                  alt=""
                />
                <img
                  className="img-fluid bg-white w-100 wow fadeIn"
                  data-wow-delay="0.4s"
                  src="images/menu-4.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="heading-section" data-aos="fade-up">
              <p className="subheading">About Us</p>
              <h1 className="mb-4 text-white z-1">
                The success history of coffee House in 25 years
              </h1>
            </div>
            <div className="row g-3 mb-4" data-aos="fade-up">
              <div className="col-sm-4">
                <img className="img-fluid bg-white w-100" src="images/coffeeImage3.jpg" alt="" />
              </div>
              <div className="col-sm-8">
                <h5>Our coffee is one of the most popular drinks in the world</h5>
                <p className="mb-0 p-color">
                Our coffee is capable of everything that reminds you of a nostalgic feel.
                   Coffee powder produced from the best quality coffee beans will change your life. 
                    Happiness will be with you  
                </p>
              </div>
            </div>
            <div className="border-top mb-4"></div>
            <div className="row g-3" data-aos="fade-up">
              <div className="col-sm-8">
                <h5>Daily use of a cup of coffee is good for your health</h5>
                <p className="mb-0 p-color">
                Our best coffee beans are sourced from selected plantations in Wayanad / Coorg which gives you a unique taste... 
                Our process unit is located at AUWM Vengeri in Kozhikode district Kerala and is 
                produced in the most hygienic manner and packed with advanced technology machinery and delivered to you... 
                </p>
              </div>
              <div className="col-sm-4">
                <img className="img-fluid bg-white w-100" src="images/about-6.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5" data-aos="fade-up">
          <div className="col-lg-5" >
            <img className="img-fluid" src="images/about-7.avif" alt="" />
          </div>
          <div className="col-lg-6">
            <div className="heading-section text-white" data-aos="fade-up">
              <span className="subheading">Featured Article</span>
              <h2 className="mb-4 text-white z-1">The history of coffee powder in the world</h2>
            </div>
            <p className="mb-4 p-color">
            We prepare for our coffee lovers a good dose of caffeine can fix half of the problems in life instantly.
             Be it to kick-start the day or to uplift your mood, freshly brewed coffee always does the job.
              Indian Robusta and Arabic coffee  We prepare Natural harvesting / washing / sunlight draying / grading / 
               roasting and  powdering  without loss aroma ,sweetness, 
               freshness  and available in various quantities. Packed and delivered to your hand  

            </p>
            <p className="mb-4 p-color">
            We assured extra ordinary taste our sera coffee. 
            Elevate your coffee traditionally by experiencing the rich aroma and amazing flavor only we can provide.
             To try to do something and you'll discover a new level of coffee enjoyment. Your taste buds will be enjoying! 

            </p>
            <a href="/about" className="btn btn-primary rounded-0 py-3 px-5">
              Read More
            </a>
          </div>
        </div>
      </div>
    </div>
    </div>
    </section>
    )
}
export default AboutUs;






